import styled from 'styled-components';

import { body2, spacing, colors } from 'ui/theme';
import { TriggerButton } from 'ui/menu/Styled';

export const FilterBanner = styled.div`
  ${body2};
  background-color: ${colors.purple100};
  color: ${colors.white};
  padding: ${spacing.base} ${spacing.plusHalf};
`;

export const DatePickerContainer = styled.div`
  display: inline-block;
`;

export const DateTriggerButton = styled(TriggerButton)`
  color: ${(props) => (props.disabled ? colors.textSecondary : colors.textPrimary)};
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  z-index: 2;
  color: ${colors.textPrimary};
  background-color: ${colors.white};
  border-radius: ${spacing.half};
`;

export const TimeText = styled.span`
  padding-right: ${spacing.plusHalf};
`;
